module.exports = __webpack_public_path__ + "img/fhr_qr.9935c8db.png";